import React, { useEffect, useState } from 'react'
import { ChecklistServicesApi } from '../../service/api/ChecklistServicesApi';
import SubmitButton from '../../components/controls/SubmitButton/SubmitButton';

import { useHistory } from "react-router-dom";

import styles from './EvaluateChecklist.module.css';
import EvaluateChecklistRow from './EvaluateChecklistRow';
import Loading from '../../components/Loading/Loading';
import GenericModal from '../../UI/GenericModal';
import { useSelector } from 'react-redux';
import InfoIconWithTooltip from "../../UI/InfoIconWithTooltip/InfoIconWithTooltip";
import { getFirstMultiDigitNumber } from '../../globalFunctions/globalFunctions';

let urlSearchParams = new URLSearchParams(window.location.search);
let params = Object.fromEntries(urlSearchParams.entries());
let queryStringChecklistId = params["checklistId"];

const hierarchyArray = ["question", "ambito", "requisito", "principio", "fatQual"]; // in this order so that for example fatQual > requisito
// const qualitativeAnswerTypes = [
//   { id: 1000001, answer: "Good" },
//   { id: 1000002, answer: "Satisfactory" },
//   { id: 1000003, answer: "Unsatisfactory" },
//   { id: 1000004, answer: "Poor" },
//   { id: 1000005, answer: "N/A" },
// ];

const EvaluateChecklist = (props) => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingButtons, setIsLoadingButtons] = useState(false);
  const [finalData, setFinalData] = useState([]);
  const [opScopes, setOpScopes] = useState([]);
  const [qualitativeAnswerTypes, setQualitativeAnswerTypes] = useState();
  const [checklistId, setChecklistId] = useState(); // if the id that is being sent to the backend
  const [qualitativeEvaluationOnly, setQualitativeEvaluationOnly] = useState(true);
  const [originalData, setOriginalData] = useState(); // will be used on save/evaluate

  const accountDetails = useSelector(state => state.accountDetails);

  // Modal
  const [modalShow, setModalShow] = useState(false);
  const [modalAction, setModalAction] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [modalMessage, setModalMessage] = useState();
  const [modalType, setModalType] = useState();
  const [modalShowInput, setModalShowInput] = useState(false);

  const history = useHistory();

  useEffect(() => {
    let mounted = true;
    setIsLoading(true);
    console.log(queryStringChecklistId)

    // const fattoriQualificanti = require("./checklist-1-data.json");
    // setOriginalData(fattoriQualificanti);

    urlSearchParams = new URLSearchParams(window.location.search);
    params = Object.fromEntries(urlSearchParams.entries());
    queryStringChecklistId = params["checklistId"];
    setChecklistId(queryStringChecklistId);

    if (accountDetails) {
      const checklistServicesApi = new ChecklistServicesApi();

      checklistServicesApi.getChecklistById(queryStringChecklistId, (checklistError, checklistInfo) => {
        if (mounted) {
          if (!checklistError) {
            const parentCompany = checklistInfo.legalEntityParentCompany.name;
            const subsidiary = checklistInfo.legalEntitySubsidiary.name;
            const company = checklistInfo.legalEntityCompany.name;
            const checklistIsInsideUserVisibility = isInsideVisibilityConeHandler(parentCompany, subsidiary, company);
            if (!checklistIsInsideUserVisibility || (checklistInfo.checklistState.name !== "To Evaluate" && checklistInfo.checklistState.name !== "WIP")) {
              console.log("Checklist with id ", checklistInfo.id, " cannot be opened in this page due to the checklist status or because the user cannot have access to this checklist due to visibility scope.");
              history.push("/checklist-monitor");
            }
            const qualitativeAnswers = checklistInfo.checklistQualitativeAnswerTypes;
            console.log("checklist info: ", checklistInfo);
            qualitativeAnswers.sort((a, b) => a.id > b.id ? 1 : -1);
            if (mounted) {
              setQualitativeAnswerTypes(qualitativeAnswers);
              props.setChecklistName(checklistInfo.name);

              checklistServicesApi.getChecklistCosoHierarchyById(queryStringChecklistId, (error, data) => {
                if (mounted) {
                  if (!error) {
                    setOriginalData(data);
                    const fattoriQualificanti = data;
                    initialConfiguration(queryStringChecklistId, fattoriQualificanti);
                  } else {
                    setError(() => {
                      throw new Error("");
                      // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
                    })
                  }
                }
              });
            }
          } else {
            setError(() => {
              throw new Error("");
              // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
            })
          }
        }
      });
    }

    return () => {
      mounted = false;
    }
  }, [accountDetails]);

  const initialConfiguration = (queryStringChecklistId, fattoriQualificanti) => {
    const initialOpScopes = [];

    // creating the initialOpScopes array
    let opScopesArrayCreated = false;
    for (let fatQual of fattoriQualificanti) {
      for (let principio of fatQual.checklistCosoPrincipi) {
        for (let requisito of principio.checklistCosoRequisiti) {
          for (let ambito of requisito.checklistCosoAmbiti) {
            if (ambito.checklistQualitativeQuestions && ambito.checklistQualitativeQuestions.length > 0) { // only needed if I receive ambiti with no questions
              for (let question of ambito.checklistQualitativeQuestions) {
                for (let opScope of question.checklistQualitativeQuestionOperationalScopes) {
                  const tempOS = {
                    id: opScope.operationalScope.id,
                    name: opScope.operationalScope.name,
                    tooltip: opScope.operationalScope.tooltip,
                    infoIconIsVisible: false
                  }
                  initialOpScopes.push(tempOS);
                }
                opScopesArrayCreated = true;
                break;
              }

            }
            
            if (ambito.checklistQuantitativeDrivers && ambito.checklistQuantitativeDrivers.length > 0) {
              for (let driver of ambito.checklistQuantitativeDrivers) {
                for (let question of driver.checklistQuantitativeQuestions) {
                  if (question.checklistQuantitativeQuestionOperationalScopes && question.checklistQuantitativeQuestionOperationalScopes.length > 0) {
                    for (let opScope of question.checklistQuantitativeQuestionOperationalScopes) {
                      const tempOS = {
                        id: opScope.operationalScope.id,
                        name: opScope.operationalScope.name,
                        active: opScope.operationalScope.active,
                        infoIconIsVisible: false
                      };
                      initialOpScopes.push(tempOS);
                      console.log("quantitativeee opScope", initialOpScopes)
                    }
                    opScopesArrayCreated = true;
                    break;
                  }
                }
              }
            }
            if (opScopesArrayCreated) break;
          }
          if (opScopesArrayCreated) break;
        }
        if (opScopesArrayCreated) break;
      }
      if (opScopesArrayCreated) break;
    }

    initialOpScopes.sort((a, b) => a.id > b.id ? 1 : -1);
    console.log("sorted opScopes: ", initialOpScopes);

    setOpScopes(initialOpScopes);

    // SORTING ALL THE ARRAYS
    fattoriQualificanti.sort((a, b) => a.position > b.position ? 1 : -1);
    for (let fatQual of fattoriQualificanti) {
      fatQual.checklistCosoPrincipi.sort((a, b) => a.position > b.position ? 1 : -1);
      for (let principio of fatQual.checklistCosoPrincipi) {
        principio.checklistCosoRequisiti.sort((a, b) => a.position > b.position ? 1 : -1);
        for (let requisito of principio.checklistCosoRequisiti) {
          requisito.checklistCosoAmbiti.sort((a, b) => a.position > b.position ? 1 : -1);
          for (let ambito of requisito.checklistCosoAmbiti) {
            if (ambito.checklistQualitativeQuestions.length > 0) {
              ambito.checklistQualitativeQuestions.sort((a, b) => a.position > b.position ? 1 : -1);
            } else {
              ambito.checklistQuantitativeDrivers.sort((a, b) => a.position > b.position ? 1 : -1);
              for (let checklistQuantitativeDriver of ambito.checklistQuantitativeDrivers) {
                checklistQuantitativeDriver.checklistQuantitativeQuestions.sort((a, b) => a.position > b.position ? 1 : -1);
              }
            }
          }
        }
      }
    }
    console.log("sortedData: ", fattoriQualificanti);

    let mainData = [];
    for (let fatQual of fattoriQualificanti) {
      mainData.push(createDataObject(fatQual, "fatQual")); // id, position(?probably not needed) title, type, operationalScopes values
      for (let principio of fatQual.checklistCosoPrincipi) {
        mainData.push(createDataObject(principio, "principio"));
        for (let requisito of principio.checklistCosoRequisiti) {
          mainData.push(createDataObject(requisito, "requisito"));
          for (let ambito of requisito.checklistCosoAmbiti) {
            if (ambito.checklistQualitativeQuestions.length > 0) {
              mainData.push(createDataObject(ambito, "ambito", "qualitative"));
              for (let question of ambito.checklistQualitativeQuestions) {
                mainData.push(
                  createQuestionObject(
                    question,
                    question.checklistQualitativeQuestionOperationalScopes,
                    fatQual.id,
                    principio.id,
                    requisito.id,
                    ambito.id,
                    initialOpScopes,
                    "qualitative",
                  ));
              }
            } else if (ambito.checklistQuantitativeDrivers && ambito.checklistQuantitativeDrivers.length > 0) {
              // if (ambito.checklistQuantitativeDrivers && ambito.checklistQuantitativeDrivers.length > 0) {
              mainData.push(createDataObject(ambito, "ambito", "quantitative"));
              setQualitativeEvaluationOnly(false);
              for (let checklistQuantitativeDriver of ambito.checklistQuantitativeDrivers) {
                for (let question of checklistQuantitativeDriver.checklistQuantitativeQuestions) {
                  mainData.push(
                    createQuestionObject(
                      question,
                      question.checklistQuantitativeQuestionOperationalScopes,
                      fatQual.id,
                      principio.id,
                      requisito.id,
                      ambito.id,
                      initialOpScopes,
                      "quantitative",
                    ));
                }
              }
            }
          }
        }
      }
    }

    // fatQual "span" property will determine the number of rows that this title will occupy
    let count = 0;
    for (let i = mainData.length - 1; i >= 0; i--) {
      const arrayEl = mainData[i];
      // length of each fattore qualificante
      if (arrayEl.type && arrayEl.type === "fatQual") {
        arrayEl.span = count;
        // Object.defineProperty(arrayEl, "span", { value: count });
        count = 0;
      } else {
        count++;
      }
    }

    setFinalData([...mainData]);
    // setFinalData(mainData);
    setIsLoading(false);
  }

  const isInsideVisibilityConeHandler = (parentCompany, subsidiary, company) => {
    const authorities = [...accountDetails.authorities];
    let isParentCompany = false;
    let isSubsidiary = false;
    let isCompany = false;
    for (const el of authorities) {
      if (el.type === "ST") {
        if (el.legalEntityParentCompany === undefined || (el.legalEntityParentCompany && el.legalEntityParentCompany.name === parentCompany)) {
          isParentCompany = true;
        }
        if (el.legalEntitySubsidiary === undefined || (el.legalEntitySubsidiary && el.legalEntitySubsidiary.name === subsidiary)) {
          isSubsidiary = true;
        }
        if (el.legalEntityCompany === undefined || (el.legalEntityCompany && el.legalEntityCompany.name === company)) {
          isCompany = true;
        }
      }
    }

    console.log("isParentCompany && isSubsidiary && isCompany: ", isParentCompany && isSubsidiary && isCompany);
    if (isParentCompany && isSubsidiary && isCompany) {
      return true;
    }
    return false;
  }

  // structure created for the displayed flattened array
  const createDataObject = ({ id, title, tooltip, position, ...props }, givenType, ambitoType) => {
    const dataObject = {
      id,
      title,
      tooltip,
      type: givenType,
      isHidden: false,
      isCollapsed: false,
      ...(givenType === "principio" && { position })
    };

    if (givenType === "ambito") {
      dataObject.ambitoType = ambitoType;
      if (ambitoType === "quantitative") {
        for (let checklistQuantitativeDriver of props.checklistQuantitativeDrivers) {
          // for (let question of checklistQuantitativeDriver.checklistQuantitativeQuestions) {}
          if (checklistQuantitativeDriver.checklistQuantitativeQuestions[0].checklistQuantitativeQuestionOperationalScopes[0].answer === null) {
            dataObject.selectedAnswerType = "na"
          } else {
            dataObject.selectedAnswerType = "qv"
          }
        }
      }

    }

    return dataObject;
  }

  // structure created for the displayed flattened array
  const createQuestionObject = (
    {
      position,
      question: title,
      id: questionId,
      tooltip,
      displayId,
      note
    },
    opScopesObjects,
    fatQualId,
    principioId,
    requisitoId,
    ambitoId,
    operationalScopes,
    questionType,
  ) => {
    // transform the opScopes information
    const tempOpScopes = [];

    for (let opScope of operationalScopes) {
      for (let opScopesObject of opScopesObjects) {
        if (opScopesObject.operationalScope.name === opScope.name) {
          let opScopeName = opScopesObject.operationalScope.name;
          let opScopeAnswer;
          if (questionType === "qualitative") {
            opScopeAnswer = opScopesObject.checklistQualitativeAnswerType ? opScopesObject.checklistQualitativeAnswerType.answer : null
          } else { // quantitative
            if (opScopesObject.answer === null) {
              opScopeAnswer = "N/A";
            } else if (opScopesObject.answer === -9999) { // unanswered field
              opScopeAnswer = "";
            } else {
              opScopeAnswer = opScopesObject.answer;
            }
          }
          let opScopeEnabled = opScopesObject.enabled;
          tempOpScopes.push({ name: opScopeName, answer: opScopeAnswer, enabled: opScopeEnabled });
          break;
        }
      }
    }

    return {
      operationalScopes: tempOpScopes,
      position,
      title,
      tooltip,
      displayId,
      fatQualId,
      principioId,
      requisitoId,
      ambitoId,
      questionId,
      questionType, // qualitative, quantitative
      note,
      isHidden: false
    };
  };

  const updateOriginalData = (record, data, operationType, opScope, newAnswer, updatedNote) => {
    for (let fatQual of data) {
      if (record.fatQualId === fatQual.id)
        for (let principio of fatQual.checklistCosoPrincipi) {
          if (record.principioId === principio.id)
            for (let requisito of principio.checklistCosoRequisiti) {
              if (record.requisitoId === requisito.id)
                for (let ambito of requisito.checklistCosoAmbiti) {
                  if (record.ambitoId === ambito.id) {
                    console.log("questionType: ", record.questionType);
                    if (record.questionType === "qualitative") {
                      for (const question of ambito.checklistQualitativeQuestions) {
                        if (question.position === record.position) {
                          switch (operationType) {
                            case "updatingQuestionAnswer":
                              let opScopeIndex = question.checklistQualitativeQuestionOperationalScopes.findIndex(scope => scope.operationalScope.name === opScope.name);
                              let questionAnswerType = question.checklistQualitativeQuestionOperationalScopes[opScopeIndex].checklistQualitativeAnswerType;
                              for (const answerType of qualitativeAnswerTypes) {
                                if (answerType.answer === newAnswer) {
                                  questionAnswerType = {
                                    id: answerType.id,
                                    answer: answerType.answer
                                  }
                                  break;
                                }
                              }
                              question.checklistQualitativeQuestionOperationalScopes[opScopeIndex].checklistQualitativeAnswerType = { ...questionAnswerType };
                              break;
                            case "updatingNotes":
                              question.note = updatedNote;
                              break;
                            default:
                          }
                        }
                      }
                    } else { // quantitative
                      for (let checklistQuantitativeDriver of ambito.checklistQuantitativeDrivers) {
                        for (const question of checklistQuantitativeDriver.checklistQuantitativeQuestions) {
                          if (question.position === record.position) {
                            switch (operationType) {
                              case "updatingQuestionAnswer":
                                let opScopeIndex = question.checklistQuantitativeQuestionOperationalScopes.findIndex(scope => scope.operationalScope.name === opScope.name);
                                if (newAnswer === "na") {
                                  newAnswer = null;
                                } else if (newAnswer === "") {
                                  newAnswer = -9999 // unanswered field
                                } else {
                                  newAnswer = parseInt(newAnswer);
                                }
                                console.log("updatingQuestionAnswer answer: ", newAnswer)
                                question.checklistQuantitativeQuestionOperationalScopes[opScopeIndex].answer = newAnswer;
                                break;
                              case "updatingNotes":
                                console.log(updatedNote);
                                question.note = updatedNote;
                                break;
                              default:
                            }
                          }
                        }
                      }
                    }
                  }
                }
            }
        }
    }
  }

  const updateOriginalHigherHierarchyElement = (record, data, operationType, newAnswer) => {
    if (operationType === "updatingAmbitoQntQstAnswers" && record.ambitoType && record.ambitoType !== "quantitative") {
      return;
    }
    let elementFound = false;
    let operationComplete = false;
    for (let fatQual of data) {
      for (let principio of fatQual.checklistCosoPrincipi) {
        if (record.id === principio.id && record.type === "principio") {
          elementFound = true;
        }
        for (let requisito of principio.checklistCosoRequisiti) {
          if (record.id === requisito.id && record.type === "requisito") {
            elementFound = true;
          }
          for (let ambito of requisito.checklistCosoAmbiti) {
            if (record.id === ambito.id && record.type === "ambito") {
              elementFound = true;
            }
            if (elementFound) {
              // if (ambito.checklistQualitativeQuestions.length > 0) {
              //   for (const question of ambito.checklistQualitativeQuestions) {

              //   }
              // } 
              if (ambito.checklistQuantitativeDrivers.length > 0) {
                for (let checklistQuantitativeDriver of ambito.checklistQuantitativeDrivers) {
                  if (operationType === "updatingAmbitoQntQstAnswers") {
                    for (const question of checklistQuantitativeDriver.checklistQuantitativeQuestions) {
                      if (newAnswer === "na") {
                        newAnswer = null;
                      } else if (newAnswer === "qv") {
                        newAnswer = -9999 // unanswered field
                      }
                      // question.checklistQuantitativeQuestionOperationalScopes[.answer = newAnswer;
                      for (const os of question.checklistQuantitativeQuestionOperationalScopes) {
                        os.answer = newAnswer;
                      }
                    }
                  }
                }
              }
            }
            console.log("elementFound && record.type === ambito ", elementFound && record.type === "ambito");
            if (elementFound && record.type === "ambito") {
              operationComplete = true;
              break;
            }
          }
          if ((elementFound && record.type === "requisito") || operationComplete) {
            operationComplete = true;
            break;
          }
        }
        if ((elementFound && record.type === "principio") || operationComplete) break;
      }
      if (elementFound) break;
    }
  }

  const updateQuestionAnswerHandler = (index, opScope, newAnswer) => {
    console.log("INDEX: " + index)
    const el = finalData[index];

    if (el.questionType === "qualitative") {
      const note = el.note;
      console.log("Nota:", note);

      const scope = el.operationalScopes.find(s => s.name === opScope.name);

      if (scope?.enabled && (newAnswer === "N/A" || newAnswer === "Unsatisfactory" || newAnswer === "Poor")) {
        if (!note || note.trim() === "") {
          console.log("Add note for question:", el.title);
          modalDataHandler(
            "",
            "Please insert Note for answer " + newAnswer,
            "error",
            () => setModalShow(false)
          );
        }
      }

    }


    console.log(...finalData)
    let newData = [...finalData];
    let opScopeIndex = newData[index].operationalScopes.findIndex(scope => scope.name === opScope.name);
    console.log("newData[index]: ", newData[index])
    newData[index].operationalScopes[opScopeIndex].answer = newAnswer;

    const record = newData[index];
    const tempDataObject = [...originalData];

    updateOriginalData(record, tempDataObject, "updatingQuestionAnswer", opScope, newAnswer); // parameters: record, data, operationType, opScope, newAnswer, updatedNote
    setOriginalData(tempDataObject);
    setFinalData(newData);
    console.log("FINE")
  }

  const changedQuantitativeAmbitoAnswerTypeHandler = (index, newValue) => {
    let newData = [...finalData];
    console.log("changedQuantitativeAmbitoAnswerTypeHandler ambito: ", newData[index])
    for (let i = index + 1; i < newData.length; i++) {
      const el = newData[i];
      if (el.type) {
        break;
      }
      if (newValue === "na") {
        el.selectedAnswerType = "na";
        el.operationalScopes.forEach(os => {
          if (os.enabled) {
            os.answer = "N/A";
          }
        })
      } else if (newValue === "qv") {
        el.selectedAnswerType = "qv";
        el.operationalScopes.forEach(os => {
          if (os.enabled) {
            os.answer = "";
          }
        })
      }
      console.log("question ", i, " :", el)
    }

    const record = newData[index];
    record.selectedAnswerType = newValue;
    const tempDataObject = [...originalData];

    updateOriginalHigherHierarchyElement(record, tempDataObject, "updatingAmbitoQntQstAnswers", newValue); // parameters: record, data, operationType, opScope, newAnswer, updatedNote
    setOriginalData(tempDataObject);
    setFinalData(newData);
  }

  // const updateQuantitativeQuestionAnswerHandler = (index, opScope, newAnswer) => {
  //   let newData = [...finalData];
  //   const opScopeIndex = newData[index].operationalScopes.findIndex(el => el.name === opScope.name);
  //   newData[index].operationalScopes[opScopeIndex].answer = newAnswer;

  //   const record = newData[index];
  //   const tempDataObject = [...originalData];

  //   updateOriginalData(record, tempDataObject, "updatingQuestionAnswer", opScope, newAnswer); // parameters: record, data, operationType, opScope, newAnswer, updatedNote
  //   setOriginalData(tempDataObject);
  //   setFinalData(newData);
  // }

  const updateNoteHandler = (index, note) => {
    let newData = [...finalData];
    newData[index].note = note;

    const record = newData[index];
    const tempDataObject = [...originalData];
    updateOriginalData(record, tempDataObject, "updatingNotes", undefined, undefined, note); // updateOriginalData(record, data, operationType, opScope, newQuestion, newTitle)

    setFinalData(newData);
  }

  const collapseElement = function (index, isCollapsedUpdatedValue) {
    // clicked elements will never be questions
    let newData = [...finalData];
    newData[index].isCollapsed = isCollapsedUpdatedValue;
    const record = newData[index];
    let newIsHiddenValue = false;
    if (isCollapsedUpdatedValue === true) {
      newIsHiddenValue = true;
    }

    console.log("isHidden new value: ", isCollapsedUpdatedValue)
    // let invalidInputFound = false;
    // DESCRIPTION of all the variables used below: (hierarchy is the order of the "layers", from question to fatQual)
    // 1. hierarchyLevelOfSelectedElement: The hierarchy of the element that was clicked
    // 2. currentCollapsedElementHierarchy: The hierachy of the current element that was detected to be collapsed while iterating through the newData array
    // 3. elHierarchy: the hierarchy of the current iteration element
    // 4. isInsideCollapsedElement: a boolean that checks if we are inside a collapsed element

    let currentCollapsedElementHierarchy = 0;
    let isInsideCollapsedElement = false;
    const hierarchyLevelOfSelectedElement = hierarchyArray.findIndex(item => item === record.type); //defining the hierarchy level of the selected element
    console.log("hierarchyLevelOfSelectedElement: ", hierarchyLevelOfSelectedElement);
    for (let i = index + 1; i < newData.length; i++) {
      let el = newData[i];
      if (el.type) {
        let elHierarchy = hierarchyArray.findIndex(type => type === el.type);
        if (elHierarchy < hierarchyLevelOfSelectedElement) {
          if (el.isCollapsed && !isInsideCollapsedElement) {
            isInsideCollapsedElement = true;
            currentCollapsedElementHierarchy = hierarchyArray.findIndex(type => type === el.type);
            el.isHidden = newIsHiddenValue;
            // if (isCollapsedUpdatedValue === true && !invalidInputFound) {
            //   if (!el.hasValidChildren) {
            //     invalidInputFound = true;
            //   }
            // }
            continue;
          }
          if (isInsideCollapsedElement) {
            if (elHierarchy >= currentCollapsedElementHierarchy) {
              if (el.isCollapsed) {
                currentCollapsedElementHierarchy = hierarchyArray.findIndex(type => type === el.type);
                // if (isCollapsedUpdatedValue === true && !invalidInputFound) {
                //   if (!el.hasValidChildren) {
                //     invalidInputFound = true;
                //   }
                // }
              } else {
                isInsideCollapsedElement = false;
              }
              el.isHidden = newIsHiddenValue;
            }
          } else {
            el.isHidden = newIsHiddenValue;
          }
        } else break;
      } else {
        // element is a question
        if (!isInsideCollapsedElement) {
          el.isHidden = newIsHiddenValue;
          // if (isCollapsedUpdatedValue === true && !invalidInputFound) {
          //   for (const value of Object.values(el.invalidInputs)) {
          //     if (value === true) {
          //       invalidInputFound = true;
          //       break;
          //     }
          //   }
          // }
        }
      }
    }
    // newData[index].hasValidChildren = invalidInputFound ? false : true;

    setFinalData(newData);
  }

  // used on Save checklist
  const isQuantitativeInvalid = () => {
    for (const el of finalData) {
      //console.log("👉 Elemento:", el); // 👈 aggiunto per ispezione

      if (el.questionType) {
        if (el.questionType === "quantitative") {
          for (let opScope of el.operationalScopes) {
            //console.log("🔍 Operational Scope:", opScope); // 👈 aggiunto per ispezione

            if (opScope.enabled) {
              const qntAnswerInvalidity = quantAnswerFn(opScope);
              if (qntAnswerInvalidity === true) {
                console.log("❌ Invalid element:", el);
                return true;
              }

            }
          }
        }
        else if (el.questionType === "qualitative") {
          console.log("QUALITATIVE")
          const note = el.note
          console.log(note)
          const titleQuestion = el.title

          for (let opScope of el.operationalScopes) {
            //console.log("🔍 Operational Scope:", opScope); // 👈 aggiunto per ispezione
            console.log(opScope.enabled)
            if (opScope.enabled) {
              const ans = (opScope.answer || "").toLowerCase();
              if (
                (ans === 'n/a' || ans === 'unsatisfactory' || ans === 'poor') &&
                (!note || note.trim() === "")
              ) {
                console.log("Inserire nota per la domanda:", titleQuestion);
                return true;
              }
            }
          }
        }
      }
    }
    return false;
  };


  // used on Validate (submit) checklist
  const areAnswersInvalid = () => {
    console.log("ANSWERSAREINVALID START")
    let ambitoId = -1;
    let n_aFound = false; // N/A is found
    let qntNumberValueFound = false;
    // for (const el of finalData) {
    for (let i = finalData.length - 1; i >= 0; i--) {
      let el = finalData[i];
      if (el.questionType) {
        if (el.questionType === "qualitative") {
          for (let opScope of el.operationalScopes) {
            if (!opScope.answer && opScope.enabled) {
              modalDataHandler("", "An answer must be selected for each operational scope.", 'error', () => setModalShow(false));
              return true;
            }
          }
        } else { // quantitative
          for (let opScope of el.operationalScopes) {
            if (opScope.enabled && opScope.answer === "") {
              modalDataHandler("", "A number value is required for all quantitative operational area fields.", 'error', () => setModalShow(false));
              return true;
            }
          }
          // if (el.position === 1) { // first question of the ambito (so the last one since we are descending the array )
          //   if (n_aFound === true && qntNumberValueFound === true) {
          //     modalDataHandler("", `Please make sure that all quantitative answers' operational areas of a KPI are either number values or set to N/A. To leave an operational area without a value, type N/A.`, 'error', () => setModalShow(false));
          //     return true;
          //   }
          // }
          // if (ambitoId !== el.ambitoId) {
          //   console.log("ambitoId: ", ambitoId)
          //   console.log("n/a Found value: ", n_aFound)
          //   console.log("qntNumberValueFound value: ", qntNumberValueFound)
          //   if (n_aFound === true && qntNumberValueFound === true) {
          //     modalDataHandler("", `Please make sure that all quantitative answers' operational areas of a KPI are either number values or set to N/A. To leave an operational area without a value, type N/A.`, 'error', () => setModalShow(false));
          //     return true;
          //   } else {
          //     n_aFound = false;
          //     qntNumberValueFound = false;
          //     ambitoId = el.ambitoId;
          //   }
          // }
          // for (let opScope of el.operationalScopes) {
          //   if (opScope.enabled) {
          //     const qntAnswerInvalidity = quantAnswerFn(opScope);
          //     if (qntAnswerInvalidity === true) {
          //       return true;
          //     } else if (qntAnswerInvalidity === "N/A" || qntAnswerInvalidity === "n/a") {
          //       console.log("n/a Found")
          //       n_aFound = true;
          //     } else { // quantAnswerFn(opScope) === false, that means the opScope is answered with a valid number
          //       qntNumberValueFound = true;
          //       console.log("qntNumberValueFound")
          //     }
          //   }
          // }
        }
      }
    }
    return false;
  }

  const quantAnswerFn = (opScope) => {
    const answer = opScope.answer; //TODO: check the payload understand why it failed. Invalid qnt answer?
    if (answer !== "N/A") {
      const isNotNumber = answer.length > 1 && answer[0] === '0'; // check if there is an invalid '0' at the start of the string
      console.log("isNotNumber", isNotNumber);
      if (
        // answer.length === 0 ||
        isNotNumber ||
        isNaN(answer) ||
        answer === null ||
        answer === undefined
      ) {
        console.log(opScope)
        modalDataHandler(
          () => "",
          "The quantitative answers values must be numeric non-negative values",
          "error",
          () => setModalShow(false)
        );
        return true;
      }
      return false;
    } else {
      return "N/A";
    }

  }

  const saveChecklistHandler = () => {

    // if (!isQuantitativeInvalid()) {

    setIsLoadingButtons(true);
    console.log("finalData: ", finalData);
    console.log("originalData ", originalData);

    const checklistServicesApi = new ChecklistServicesApi();
    checklistServicesApi.updateChecklistHierarchy(originalData, queryStringChecklistId, (error, data) => { // (id, callback)
      console.log("Questions saved response: ", data);
      if (!error) {
        setIsLoadingButtons(false); // this setter is not outside the if statement because if it was, when the component unmounts, we get a memory leak warning becaues we would 
        // be trying to update an unmounted component
        modalDataHandler("", `The checklist with id ${checklistId} is saved!`, 'notification', () => history.push("/checklist-monitor"))
      } else {
        setIsLoadingButtons(false);
        modalDataHandler(``, "Error! The checklist was not saved!", 'error', () => setModalShow(false));
      }
    });

    //}
    /*
    else {
      modalDataHandler("", "Please insert Note for negative answers", 'error', () => setModalShow(false));
    }
    */

  }

  const confirmValidateChecklist = () => {
    if (!areAnswersInvalid()) {
      console.log("API WORKED");
      setIsLoadingButtons(true);
      console.log("finalData: ", finalData);
      console.log("originalData ", originalData);
      const checklistServicesApi = new ChecklistServicesApi();
      checklistServicesApi.updateChecklistHierarchy(originalData, queryStringChecklistId, (saveError, data) => { // (id, callback)
        console.log("Questions saved response: ", data);
        if (!saveError) {
          checklistServicesApi.confirmed(queryStringChecklistId, (confirmError, data) => {
            console.log(data);
            if (!confirmError) {
              setIsLoadingButtons(false);
              modalDataHandler("", `The checklist with id ${checklistId} was Confirmed`, 'notification', () => history.push("/checklist-monitor"));
            } else {
              setIsLoadingButtons(false);
              modalDataHandler(``, "Error! The checklist was saved but could not be validated!", 'error', () => setModalShow(false));
            }
          });
        } else {
          setIsLoadingButtons(false);
          modalDataHandler(`error ${(saveError.response ? saveError.response.statusCode : "")}`, "Error! The checklist was not saved!", 'error', () => setModalShow(false));
        }
      });
    }
  }

  // VALIDATE BUTTON
  const confirmChecklistHandler = () => {
    console.log("confirmChecklistHandler")
    if (isQuantitativeInvalid()) {
      console.log("isQuantitativeInvalid")
      modalDataHandler
        (
          "Are you sure you want to proceed? ",
          "No notes entered for negative answer, do you want to proceed?",
          'confirmation',
          () => confirmValidateChecklist()
        );
    }

    else {
      confirmValidateChecklist()
    }
  }

  const modalDataHandler = (title, message, modType, action, showModalInput = false) => {
    setModalTitle(title);
    setModalMessage(message);
    setModalShow(true);
    setModalType(modType)
    setModalAction(() => action);
    setModalShowInput(showModalInput);
  }

  const modalCloseHandler = () => {
    setModalShow(false)
  }

  function genRandomWord() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    const range = parseInt(Math.random() * 170);
    for (var i = 0; i < range; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  }

  // Table Header
  const renderHeader = () => {
    console.log("Header rendered");
    return (
      <thead>
        <tr>
          <th rowSpan="2" className={`${styles.fatQual} bg-transparent border-bottom-0`}></th>
          <th rowSpan="2" className={`${styles.bgGrey} ${styles.questionsWidth} text-white align-middle`}>
            Questions
          </th>
          <th colSpan={opScopes.length} className={`${styles.bgGrey} text-white align-middle`}>
            Operational Scopes
          </th>
          <th rowSpan="2" className={`${styles.bgGrey} ${styles.notesWidth} text-white align-middle`}>NOTE</th>
        </tr>
        <tr>
          {finalData && opScopes.map((opScope) => (
            <th key={`${opScope.id} - ${opScopes.name}`} className={`${styles.opScopeWidth} position-relative py-1 px-2`}
              onMouseEnter={(e) => showOpScopeInfoIcon(e, opScope.id)}
              onMouseLeave={(e) => hideOpScopeInfoIcon(e, opScope.id)}
            >
              {opScope.name}
              <InfoIconWithTooltip text={opScope.tooltip} show={opScope.infoIconIsVisible} />
            </th>
          ))}
        </tr>
      </thead>
    );
  }

  const showOpScopeInfoIcon = (e, osId) => {
    e.preventDefault();

    const updatedOpScopes = [...opScopes];
    updatedOpScopes.filter(os => os.id === osId)[0].infoIconIsVisible = true;

    setOpScopes(updatedOpScopes)
  };

  const hideOpScopeInfoIcon = (e, osId) => {
    e.preventDefault();

    const updatedOpScopes = [...opScopes];
    updatedOpScopes.filter(os => os.id === osId)[0].infoIconIsVisible = false;

    setOpScopes(updatedOpScopes)
  };

  let transformedData = finalData && [...finalData];

  let fatQualSpan = 0;
  for (let i = transformedData.length - 1; i >= 0; i--) {
    let el = transformedData[i];
    if (el.type && el.type === "fatQual") { // we don't count the elements that are hidden
      el.span = fatQualSpan;
      fatQualSpan = 0;
    } else {
      if (!el.isHidden)
        fatQualSpan++;
    }
  }

  let principioDisplayId = 1;
  let tableData = transformedData && transformedData.map((el, index) => {
    if (el.type === "principio") {
      principioDisplayId = getFirstMultiDigitNumber(el.title);
    }
    if (el.type && el.type === "fatQual") {
      console.log(el.span);
      return (
        <tr key={el.id}>
          <td className={styles.fatQual} rowSpan={el.span + 1}>
            <span className={styles.verticalText}>{el.title}</span>
          </td>
        </tr>
      );
    } else {
      if (!el.isHidden) {
        console.log("!el.isHidden: " + !el.isHidden)
        return (
          <EvaluateChecklistRow
            key={el.type ? el.type + "-" + el.id : el.questionType + "-" + index}
            title={el.title}
            opScopes={el.operationalScopes}
            type={el.type}
            pos={index}
            questionType={el.questionType}
            ambitoType={el.ambitoType}
            selectedAnswerType={el.selectedAnswerType}
            isCollapsed={el.isCollapsed}
            hasValidChildren={el.hasValidChildren}
            tooltip={el.tooltip}
            principioId={principioDisplayId}
            displayId={el.displayId}
            updateQuestionAnswer={updateQuestionAnswerHandler}
            changedQuantitativeAmbitoAnswerType={changedQuantitativeAmbitoAnswerTypeHandler}
            updateNote={updateNoteHandler}
            qualitativeAnswers={qualitativeAnswerTypes.map((el) => el.answer)}
            collapseElement={collapseElement}
            qualEvaluationOnly={qualitativeEvaluationOnly}
            opScopesList={opScopes}
            note={el.note}
          // tooltip={`What if this tooltip had more text? ${genRandomWord()} \n \n What if this tooltip had more text?What if this tooltip had more text? \n What if this tooltip had more text? What you do?`}
          //     tooltip={`Does The Group use a code of ethics or a code of conduct that contains:
          // a. rights, duties and responsibilities of the institution towards “stakeholders” (employees, suppliers, customers, Public Administration, shareholders, financial market, etc.)
          // b. principles of behavior and of conduct required of employees and contractors in general`}
          />
        );
      }
    }
  });

  const tableStyle = `${styles.border2px} ${styles.table} text-center table`;
  let table = (
    <table className={`${tableStyle} ${styles.tableRelative} mb-1`}>
      {/* {renderHeader()} */}
      <tbody>
        {tableData}
      </tbody>
    </table>
  );

  console.log("accountDetails: ", accountDetails);
  console.log("finalData: ", finalData);
  console.log("OriginalData", originalData);
  // console.log("quantitative drivers ", originalData ? originalData[3].checklistCosoPrincipi[0].checklistCosoRequisiti[2].checklistCosoAmbiti[0].checklistQuantitativeDrivers[0].checklistQuantitativeQuestions[0].checklistQuantitativeQuestionOperationalScopes : "");
  console.log("render: end");
  return (
    <div className={`position-relative outerContainer`}>
      <GenericModal
        show={modalShow}
        handleClose={modalCloseHandler}
        action={modalAction}
        title={modalTitle}
        message={modalMessage}
        modalType={modalType}
        showInput={modalShowInput}
      />
      {isLoading && <Loading />}
      {!isLoading && (
        <table className={`${tableStyle} ${styles.sticky} mb-0`}>
          {renderHeader()}
        </table>
      )}
      {!isLoading && table}
      {!isLoadingButtons && !isLoading && (
        <div className="d-flex justify-content-center">
          <SubmitButton
            click={() =>
              modalDataHandler(
                "Save Checklist",
                "Save Questions?",
                "confirmation",
                saveChecklistHandler
              )
            }
          >
            Save
          </SubmitButton>
          <SubmitButton
            click={() =>
              modalDataHandler(
                "Confirm Checklist",
                "Save Questions and Confirm Checklist?",
                "confirmation",
                confirmChecklistHandler
              )
            }
          >
            Validate
          </SubmitButton>{" "}
          {/* onClick={evaluateChecklistHandler} */}
        </div>
      )}
      {isLoadingButtons && <Loading />}
    </div>
  );
}

export default EvaluateChecklist;
